import { _ } from "~/i18n";
import Dialog from "~/ui/dialog";
import { node, text } from "~/util/dom";
import createSDSIcon from "~/ui/icon";
import { CHECK_24 } from "~/util/sds-compatible-icons";

export type TPreloginMotivation = "none" | "common" | "gpx" | "report" | "save" | "review" | "photo" | "like" | "traffic";

export type TPreloginAnalytics = "none" | "save" | "photoUpload" | "reviewsAdd" | "reviewsLike" | "photoLike" | "myMaps" | "photoReport" | "reviewsReport" | "accountDialog" | "shareLocation" | "trafficPoi" | "import" | "errorReportForm";

interface IPreloginDialogOptions {
	motivation: TPreloginMotivation;
	onLogin: () => void;
	onClose: () => void;
}

function motivationToTitle(motivation: TPreloginMotivation) {
	switch (motivation) {
		case "gpx": return _("prelogin.title.gpx", { start: "<strong>", end: "</strong>" });

		case "like": return _("prelogin.title.like", { start: "<strong>", end: "</strong>" });

		case "report": return _("prelogin.title.report", { start: "<strong>", end: "</strong>" });

		case "photo": return _("prelogin.title.photo", { start: "<strong>", end: "</strong>" });

		case "review": return _("prelogin.title.review", { start: "<strong>", end: "</strong>" });

		case "save": return _("prelogin.title.save", { start: "<strong>", end: "</strong>" });

		case "traffic": return _("prelogin.title.traffic", { start: "<strong>", end: "</strong>" });

		default: return _("prelogin.title.common", { start: "<strong>", end: "</strong>" });
	}
}

export default class PreloginDialog {
	#dialog: Dialog;

	constructor(options: IPreloginDialogOptions) {
		this.#dialog = new Dialog({
			className: "prelogin-dialog",
			onClose: options.onClose,
		});

		const content = node("div", { className: "prelogin-dialog__content" });

		// top obrázek
		const imageHero = node("div", { className: "prelogin-dialog__hero" });
		const image = node("img", { src: "/img/ui/dialogs/prelogin-dialog/top.jpg", srcset: "/img/ui/dialogs/prelogin-dialog/top.jpg, /img/ui/dialogs/prelogin-dialog/top@2x.jpg 2x" });

		imageHero.append(image);

		// nadpis
		const title = node("h2", { innerHTML: motivationToTitle(options.motivation) });

		// důvody pro přihlášení
		const more = node("p", {}, _("prelogin.more"));
		const reasonList = node("ul");
		const reasons = [
			_("prelogin.reason1"),
			_("prelogin.reason2"),
			_("prelogin.reason3"),
			_("prelogin.reason4"),
		];

		reasonList.append(...reasons.map(reason => {
			const li = node("li");

			li.append(createSDSIcon({
				symbol: CHECK_24,
			}), text(reason));

			return li;
		}));

		// přihlašovací tlačítko
		const loginButton = node("button", { type: "button", className: "prelogin-dialog__button" }, _("prelogin.button"));

		loginButton.addEventListener("click", options.onLogin, false);

		// loga pod tlačítkem
		const logos = node("div", { className: "prelogin-dialog__logos" });

		logos.append(
			node("img", { src: "/img/ui/dialogs/prelogin-dialog/seznam.svg" }),
			node("img", { src: "/img/ui/dialogs/prelogin-dialog/google.svg" }),
			node("img", { src: "/img/ui/dialogs/prelogin-dialog/microsoft.svg" }),
			node("img", { src: "/img/ui/dialogs/prelogin-dialog/apple.svg" }),
		);

		// nahážeme to všechno do dialogu
		content.append(title, more, reasonList, loginButton, logos);
		this.#dialog.dom.content.append(imageHero, content);
	}

	destroy() {
		this.#dialog.destroy();
	}

	open() {
		this.#dialog.open();
	}

	close() {
		this.#dialog.close();
	}
}
